import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { Box, Grid, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { SimTypography } from 'components/SimTypography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import faqs from './data';

const FaqGroupItem = ({ title, items }) => {
	const theme = useTheme();
	return (
		<Box>
			<Box marginBottom={2} marginX={2}>
				<SimTypography fontWeight={700} variant={'h5'}>
					{title}
				</SimTypography>
			</Box>
			<Box>
				{items.map((item, i) => (
					<Box
						component={Accordion}
						key={i}
						padding={1}
						marginBottom={i === item.length - 1 ? 0 : 2}
						borderRadius={`${theme.spacing(1)} !important`}
						sx={{
							'&::before': {
								display: 'none'
							}
						}}>
						<Box
							component={AccordionSummary}
							expandIcon={<ExpandMoreIcon />}
							aria-controls='panel1a-content'
							id={`panel1a-header--${i}`}>
							<SimTypography fontWeight={600}>{item.title}</SimTypography>
						</Box>
						<AccordionDetails>
							<SimTypography color='text.secondary'>{item.subtitle}</SimTypography>
						</AccordionDetails>
					</Box>
				))}
			</Box>
		</Box>
	);
};

FaqGroupItem.propTypes = {
	title: PropTypes.string.isRequired,
	items: PropTypes.array.isRequired
};

const Content = () => {
	return (
		<Box>
			<Grid>
				<Grid item md={4} data-aos={'fade-up'} padding={1}>
					<Box display='flex'>
						<Box marginBottom={6} display='flex'>
							<Box height={1} width={1} padding={1}>
								<FaqGroupItem sx={{ marginY: '20px' }} items={faqs} />
							</Box>
						</Box>

						<Box
							component={'img'}
							src={
								'https://149814860.v2.pressablecdn.com/wp-content/uploads/2021/07/12.-Unstuck-with-calming.png'
							}
							boxShadow={24}
							sx={{
								maxWidth: { xs: 250, sm: 250, md: 380, lg: 400 },
								marginTop: 'auto',
								marginBottom: 'auto',
								height: 'auto',
								alignContent: 'center',
								right: 0,
								display: { xs: 'none', md: 'block' },
								borderRadius: '50% 50% 50% 50%',
								marginLeft: '5vw',
								marginRight: '3vw'
							}}
						/>
					</Box>
				</Grid>
			</Grid>
		</Box>
	);
};

export default Content;
